if (!customElements.get('collection-header')) {
  class CollectionHeader extends HTMLElement {
    constructor() {
      super();
      this.bindOnScroll = this.onScroll.bind(this);
      this.bindOnResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.menu = this.querySelector('.collection__header__menu');
      this.anchor = document.querySelector('.collection__header-anchor');
      if (this.hasAttribute('sticky') && this.anchor) {
        this.currentScroll = Math.round(window.pageYOffset || document.documentElement.scrollTop);
        this.onScroll();
        this.onResize();
        window.addEventListener('scroll', this.bindOnScroll);
        if (this.menu) window.addEventListener('resize', this.bindOnResize);
      }
    }

    disconnectedCallback() {
      if (this.hasAttribute('sticky') && this.anchor) {
        window.removeEventListener('scroll', this.bindOnScroll);
        if (this.menu) window.removeEventListener('resize', this.bindOnResize);
      }

    }

    onScroll() {
      const stickyTop = computePixelValue(getComputedStyle(this).getPropertyValue('--sticky-top') || 0);
      this.classList.toggle('floating', this.anchor.getBoundingClientRect().top <= stickyTop);
      const scroll = Math.round(window.pageYOffset || document.documentElement.scrollTop);
      if (this.currentScroll > scroll) this.classList.add('scroll-up');
      else if( this.currentScroll < scroll) this.classList.remove('scroll-up');
      this.currentScroll = scroll;
    }

    onResize() {
      this.classList.remove('floating');
      this.menu.classList.remove('loaded');
      this.menu.style.setProperty('--menu-height', `${this.menu.getBoundingClientRect().height}px`);
      this.anchor.style.setProperty('--collection-header-height', `${this.getBoundingClientRect().height}px`)
      if(this.getBoundingClientRect().top <= 0) {
        this.classList.add('floating');
      }
      this.menu.classList.add('loaded');
    }
  }

  customElements.define('collection-header', CollectionHeader);
}